<template>
  <div v-if="!noResultsState" id="serp__filters-list--container"
       class="serp__filters-list--container  q-container q-p-3 q-p-md-2 q-bg-light q-pb-1">
    <UsedFilterContainer v-if="!isMobileView"/>
    <FilterItemContainer v-for="(filter, index) in getFilters" :key="filter.field" :filter="filter"
                         :filter-collapsed="isMobileView ? index >= 1 : index >= 3"/>
  </div>
</template>

<script setup lang="ts">
import FilterItemContainer from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItemContainer.vue";
import UsedFilterContainer from "@/components/SerpPage/FiltersContainer/UsedFilterContainer.vue";
import {storeToRefs} from "pinia";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {useMobileViewStore} from "@/store/MobileViewStore";

const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore();
const {getFilters} = storeToRefs(filtersStore)
const {isMobileView} = storeToRefs(mobileViewStore)
const serpStore = useSerpResultsStore();
const {noResultsState} = storeToRefs(serpStore)

</script>

<style scoped>
#serp__filters-list--container > div:first-child {
  margin-top: 0 !important;
}
</style>